export default __webpack_public_path__ + "static/media/IMG_9969.8818d68f.jpg";